<template>
    <div style="height: auto; width: auto">
        <transition name="fade2">
            <add-catagory v-if="showModal('addCatagory')"></add-catagory>
            <add-jewelry v-if="showModal('addJewelry')"></add-jewelry>
        </transition>
        <router-view></router-view>
    </div>
</template>

<script>
    import AddCatagory from '../src/components/cms/modals/AddCatagory.vue'
    import AddJewelry from '../src/components/cms/modals/AddJewelry.vue'
    //template exports
    export default {
        components: {
            AddCatagory,
            AddJewelry
        },
        methods: {
            showModal(type) {
                let { showingModal } = this.$store.state
                if (showingModal.active && showingModal.name === type) return true
                else return false
            }
        }
    }
</script>

<style lang="scss">
@font-face {
    font-family: 'DINPro Bold';
    src: url('./assets/fonts/DINProBold.otf');
}
@font-face {
    font-family: 'DINPro Regular';
    src: url('./assets/fonts/DINProRegular.otf');
}
@font-face {
    font-family: 'DINPro Light';
    src: url('./assets/fonts/DINProLight.ttf');
}
::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.v-btn__content {
    font-family: 'DINPro Regular';
}
.fade2-enter-active, .fade2-leave-active {
    transition: opacity .2s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.inner-modal, .modal-container, .modal-inner-vertical {
    display: flex;
}
.inner-modal, .modal-container {
    align-items: center;
    justify-content: center;
}
.inner-modal {
    background-color: white;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    height: auto;
    width: auto;
    flex-flow: row;
}
.modal-container {
    height:100vh; 
    width: 100vw; 
    overflow-y: hidden !important;
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(0,0,0,0.8);
    z-index: 9999;
}
.modal-inner-vertical {
    flex-flow: column;
    height: 100%;
    width: 100%;
    align-items: center;
    padding-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// App.vue?49c44542